// src/utils/helpers.js
import { Activity } from 'lucide-react';
import React from 'react';

export const BRANDING = {
  appName: "CardioAgenda",
  doctorName: "Dr. Fonseca",
  specialty: "Cardiología Clínica - Medicina Interna",
  primaryColor: "bg-blue-900",
  secondaryColor: "bg-blue-600",
  logoIcon: <Activity size={32} className="text-red-500" />
};

export const INITIAL_DATA = {
  config: {
    isBookingEnabled: true, 
    isMaintenanceMode: false,
    dolarRate: 45.50,
    rateUpdatedAt: getTodayFormatted(),
    consultaPriceRef: 50,
    adminFee: 0.80,
    examLimit: 4,
    whatsapp: "584249309876",
    clinicShare: 30,
    importantInfo: "Solo se otorgan citas para la semana en curso y la siguiente. Recuerde llegar 15 minutos antes.",
    step1: "Llene el formulario con sus datos personales.",
    step2: "El sistema le asignará una hora aproximada y generará un comprobante.",
    step3: "Finalice el proceso reportando el pago vía WhatsApp."
  },
  auth: { admin: "Simba321*", secretary: "sec123", accountant: "cont123" },
  faqs: [
    { id: 1, keywords: ["metodo", "pago"], q: "¿Qué métodos de pago aceptan?", a: "Aceptamos Pago Móvil, Transferencia, Divisas y Punto de Venta." },
  ],
  appointments: [],
  logs: [],
  clinicalRecords: {}
};

export const formatCurrency = (amount, currency = 'USD') => currency === 'USD' ? `$${parseFloat(amount || 0).toFixed(2)}` : `Bs ${parseFloat(amount || 0).toFixed(2)}`;

export function getTodayFormatted() { 
    const d = new Date(); 
    return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth()+1).toString().padStart(2, '0')}/${d.getFullYear()}`; 
}

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  if (typeof dateString === 'string' && dateString.includes('-') && dateString.length === 10) {
     const [year, month, day] = dateString.split('-');
     return `${day}/${month}/${year}`;
  }
  return dateString;
};

export const getDayName = (dateStr) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  const date = new Date(y, m - 1, d, 12, 0, 0);
  const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  return days[date.getDay()];
};

export const getWeekNumber = (dateStr) => {
  if (!dateStr) return 0;
  const [y, m, d] = dateStr.split('-');
  const date = new Date(y, m - 1, d, 12, 0, 0);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  const yearStart = new Date(date.getFullYear(), 0, 1);
  return Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
};

export const formatTimeSlot = (index) => {
    const startHour = 8; 
    const hourRaw = startHour + index; 
    const period = hourRaw >= 12 ? 'PM' : 'AM';
    let displayHour = hourRaw > 12 ? hourRaw - 12 : hourRaw;
    if (displayHour === 0) displayHour = 12;
    return `${displayHour}:00 ${period}`;
};

export const parseTime = (timeStr) => {
    if (!timeStr) return 9999;
    const [time, modifier] = timeStr.split(' ');
    if (!time || !modifier) return 9999;
    let [hours, minutes] = time.split(':');
    if (hours === '12') hours = '00';
    if (modifier === 'PM') hours = parseInt(hours, 10) + 12;
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
};

export const generateLogID = () => Math.random().toString(36).substr(2, 9);